import React, { useState, useEffect } from "react";
import { Redirect, Route, Link } from "react-router-dom";

import api from "../services/api";

export default function BonusTerms(props) {
  const [pageContent, setPageContent] = useState("");
  const getContentPage = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "responsible_gaming",
    });

    if (response.status == 200) {
      setPageContent(response.data);
    }
  };

  useEffect(() => {
    getContentPage();
  }, []);
  const renderHTML = (rawHTML: string) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

  return (
    <>
      <div class="container-xxl">
        <section className="contentPage">
          <div className="pageTitle">
            {pageContent && pageContent.content_data.page_title}
          </div>
          <div className="paragraph">
            {pageContent && renderHTML(pageContent.content_data.content)}
          </div>
        </section>

        <section className="contentPage d-none">
          <div className="pageTitle">
            <h1>Bonus Terms</h1>
          </div>
          <div className="paragraph">
            <p>
              <strong>Last updated: March 03, 2025</strong>
            </p>

            <ol>
              <li>
                Every individual promotion will come with its own set of
                specific promotional terms and conditions (the “Promotional
                Terms”) in addition to these Terms. You should therefore read
                these Terms in combination with the applicable Promotional Terms
                for any competition, bonus, or promotion you wish to enter.
              </li>
              <li>
                By participating in promotions you agree to be bound by these
                Bonus Terms and chilirojo’s general Terms and Conditions.
              </li>
              <li>
                Participation in a promotion will be deemed to constitute full
                and unconditional acceptance of the Bonus Terms, general Terms
                and Conditions, and any applicable Promotional Terms and that
                our decisions are final and binding in all respects.
              </li>
              <li>
                chilirojo.com reserves the right to terminate or cancel any
                current promotion without prior notification. Any user who
                infringes the Bonus Terms, or general Terms and Conditions, will
                be disqualified from any reward derived from said promotion.
              </li>
              <li>
                chilirojo.com has the rights to withhold any credits, bonuses,
                vouchers, loyalty points, or prizes awarded as part of a
                promotion at its own discretion.
              </li>
              <li>
                chilirojo.com has the right to inform users about current
                promotions or any updates by e-mail, SMS, chat, WhatsApp, social
                media, mobile phone, Internet browser notification, or mobile
                application.
              </li>
              <li>
                chilirojo.com disclaims any liability for inaccurate
                information, whether caused by the Website, user's equipment
                used in a promotion, or by human or technical errors related to
                the submission of entries.
              </li>
              <li>
                chilirojo regularly offers different bonuses and rewards that
                are credited to your Account, including free spins, cashback,
                free bets, and bonus money.
              </li>
              <li>A bonus is awarded to the bonus balance.</li>
              <li>
                If bonuses are abused, chilirojo.com has the right to delete,
                decline, or block the user's account.
              </li>
              <li>
                Malfunction voids all pays and plays. chilirojo.com has the
                right to withdraw winnings caused by a malfunction.
              </li>
              <li>
                Users should read and follow any applicable bonus policy to
                receive the bonus.
              </li>
              <li>
                All bonuses have an expiry date of 30 days unless otherwise
                stated.
              </li>
              <li>
                The standard betting requirement for casino bonus money is 40x
                the bonus amount unless otherwise stated.
              </li>
              <li>Free spin winnings are paid out as bonus money.</li>
              <li>
                Bonus money and remaining free spins are forfeited upon
                withdrawal.
              </li>
              <li>
                Bonus balance or free spins are not returned to the player if
                they cancel their withdrawal.
              </li>
              <li>
                <strong>Game Contribution to Wagering Requirement:</strong>
              </li>
              <ul>
                <li>Slots – 100% (except for specific exclusions)</li>
                <li>Live Games – 0%</li>
                <li>Table Games – 0%</li>
                <li>Video Poker – 0%</li>
                <li>All other games – 0%</li>
              </ul>
              <li>
                A bonus can have individually stated terms and conditions. If
                not stated, a bonus can only be used once and expires after 30
                days.
              </li>
              <li>Max bet when playing with real money on slots is USD 10.</li>
              <li>
                When participating in a free bonus (received without making a
                deposit), the maximum withdrawal is USD 500.
              </li>
              <li>Withdrawals from free spins are unlimited.</li>
              <li>Winnings from mixed bets become bonus money.</li>
              <li>
                chilirojo reserves the right to change these terms at any moment
                without informing the player.
              </li>
              <li>General Terms and Conditions apply.</li>
            </ol>

            <h2>Withdrawal Terms</h2>
            <ul>
              <li>
                Minimum withdrawal is USD 40 for any payment method available at
                our casino website.
              </li>
              <li>
                Bonus money and remaining free spins are forfeited upon
                withdrawal.
              </li>
            </ul>

            <p>
              <strong>chilirojo general Terms and Conditions apply.</strong>
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
